import * as React from 'react';
import EDOpen from '../../../../../../BaseComponents/Open/EDOpen';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import TypeTreePickerDialog from './TypeTreePickerDialog';
import { ITypeTreeConditionObject } from '../../../../../../Types/UrvalTypes';

interface IProps {
  conditionObject: ITypeTreeConditionObject;
  setConditionObject: (newConditionObject: ITypeTreeConditionObject) => void;
  disabled?: boolean;
}

const TypeTreePickerDialogButton = (props: IProps) => {
  const { conditionObject, setConditionObject, disabled } = props;

  return (
    <EDOpen>
      {(open, onOpen, onClose) => (
        <React.Fragment>
          <EDIconButton
            tooltip="Välj typ"
            icon="more_vert"
            onClick={onOpen}
            margin="none"
            disabled={disabled}
          />
          <TypeTreePickerDialog
            open={open}
            onClose={onClose}
            conditionObject={conditionObject}
            setConditionObject={setConditionObject}
          />
        </React.Fragment>
      )}
    </EDOpen>
  );
};

export default TypeTreePickerDialogButton;
